var _style, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 -15 180 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .heavy { font: bold 30px sans-serif; }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 33,
    className: "heavy",
    fill: "#F8B432"
  }, "@")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 35,
    className: "heavy"
  }, "Email")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailText);
export default __webpack_public_path__ + "static/media/EmailText.ee8a5bc5.svg";
export { ForwardRef as ReactComponent };